import { LayaGL } from "../layagl/LayaGL";
import { Color } from "../maths/Color";
import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { RenderTexture } from "../resource/RenderTexture";
import { Browser } from "./Browser";
var _gid = 1;
const _pi = 180 / Math.PI;
const _pi2 = Math.PI / 180;
export class Utils {
    static toRadian(angle) {
        return angle * _pi2;
    }
    static toAngle(radian) {
        return radian * _pi;
    }
    static toHexColor(color) {
        return Color.hexToString(color);
    }
    static fromStringColor(value) {
        return Color.stringToHex(value);
    }
    static getGID(target, method) {
        let cid = target ? (target[objUidKey] || (target[objUidKey] = _gid++)) : 0;
        let mid = method ? (typeof (method) === "string" ? method : (method[objUidKey] || (method[objUidKey] = _gid++))) : 0;
        return cid + "_" + mid;
    }
    static copyArray(source, array) {
        source || (source = []);
        if (!array)
            return source;
        source.length = array.length;
        var len = array.length;
        for (let i = 0; i < len; i++) {
            source[i] = array[i];
        }
        return source;
    }
    static parseInt(str, radix = 0) {
        var result = parseInt(str, radix);
        if (isNaN(result))
            return 0;
        return result;
    }
    static getBaseName(path) {
        let i = path.lastIndexOf("/");
        if (i != -1)
            path = path.substring(i + 1);
        i = path.indexOf("?");
        if (i != -1)
            path = path.substring(0, i);
        return path;
    }
    static getFileExtension(path) {
        let i = path.lastIndexOf(".");
        if (i != -1) {
            let ext = path.substring(i + 1).toLowerCase();
            let j = ext.indexOf("?");
            if (j != -1)
                ext = ext.substring(0, j);
            if (ext === "ls") {
                let k = path.lastIndexOf(".", i - 1);
                if (k != -1) {
                    let ext2 = path.substring(k + 1, i + 1) + ext;
                    if (ext2 === "lanit.ls" || ext2 === "ltcb.ls")
                        return ext2;
                }
            }
            return ext;
        }
        else
            return "";
    }
    static replaceFileExtension(path, newExt, excludeDot) {
        if (!path)
            return path;
        let i = path.lastIndexOf(".");
        if (newExt.length > 0 && !excludeDot)
            newExt = "." + newExt;
        if (i != -1) {
            let j = path.indexOf("?", i);
            if (j != -1)
                return path.substring(0, i) + newExt + path.substring(j);
            else
                return path.substring(0, i) + newExt;
        }
        else
            return path + newExt;
    }
    static isUUID(str) {
        return str && str.length >= 36 && str.charCodeAt(8) === 45 && str.charCodeAt(13) === 45;
    }
    static uint8ArrayToArrayBuffer(rendertexture) {
        let pixelArray;
        const width = rendertexture.width;
        const height = rendertexture.height;
        const pixelCount = width * height * 4;
        const colorFormat = (rendertexture instanceof RenderTexture) ? rendertexture.colorFormat : rendertexture.getColorFormat();
        switch (colorFormat) {
            case RenderTargetFormat.R8G8B8:
            case RenderTargetFormat.R8G8B8A8:
                pixelArray = new Uint8Array(pixelCount);
                break;
            case RenderTargetFormat.R16G16B16A16:
                pixelArray = new Float32Array(pixelCount);
                break;
            default:
                throw "this function is not surpprt " + rendertexture.format.toString() + "format Material";
        }
        LayaGL.textureContext.readRenderTargetPixelData(rendertexture._renderTarget, 0, 0, width, height, pixelArray);
        if (colorFormat === RenderTargetFormat.R16G16B16A16) {
            const ori = pixelArray;
            const trans = new Uint8Array(pixelCount);
            for (let i = 0, n = ori.length; i < n; i++) {
                trans[i] = Math.min(Math.floor(ori[i] * 255), 255);
            }
            pixelArray = trans;
        }
        const pixels = pixelArray;
        const canvas = Browser.createElement("canvas");
        canvas.height = height;
        canvas.width = width;
        const ctx2d = canvas.getContext('2d');
        const imgdata = ctx2d.createImageData(width, height);
        imgdata.data.set(new Uint8ClampedArray(pixels));
        ctx2d.putImageData(imgdata, 0, 0);
        const base64String = canvas.toDataURL();
        canvas.remove();
        return base64String;
    }
    static uint8ArrayToArrayBufferAsync(rendertexture) {
        let pixelArray;
        const width = rendertexture.width;
        const height = rendertexture.height;
        const pixelCount = width * height * 4;
        const colorFormat = (rendertexture instanceof RenderTexture) ? rendertexture.colorFormat : rendertexture.getColorFormat();
        switch (colorFormat) {
            case RenderTargetFormat.R8G8B8:
            case RenderTargetFormat.R8G8B8A8:
                pixelArray = new Uint8Array(pixelCount);
                break;
            case RenderTargetFormat.R16G16B16A16:
                pixelArray = new Float32Array(pixelCount);
                break;
            default:
                throw "this function is not surpprt " + rendertexture.format.toString() + "format Material";
        }
        return rendertexture.getDataAsync(0, 0, width, height, pixelArray).then(() => {
            if (colorFormat === RenderTargetFormat.R16G16B16A16) {
                const ori = pixelArray;
                const trans = new Uint8Array(pixelCount);
                for (let i = 0, n = ori.length; i < n; i++) {
                    trans[i] = Math.min(Math.floor(ori[i] * 255), 255);
                }
                pixelArray = trans;
            }
            const pixels = pixelArray;
            const canvas = Browser.createElement("canvas");
            canvas.height = height;
            canvas.width = width;
            const ctx2d = canvas.getContext('2d');
            const imgdata = ctx2d.createImageData(width, height);
            imgdata.data.set(new Uint8ClampedArray(pixels));
            ctx2d.putImageData(imgdata, 0, 0);
            const base64String = canvas.toDataURL();
            canvas.remove();
            return Promise.resolve(base64String);
        });
    }
    static parseTemplate(template, vars) {
        let pos1 = 0, pos2, pos3;
        let tag;
        let value;
        let result = "";
        while ((pos2 = template.indexOf("{", pos1)) != -1) {
            if (pos2 > 0 && template.charCodeAt(pos2 - 1) == 92) {
                result += template.substring(pos1, pos2 - 1);
                result += "{";
                pos1 = pos2 + 1;
                continue;
            }
            result += template.substring(pos1, pos2);
            pos1 = pos2;
            pos2 = template.indexOf("}", pos1);
            if (pos2 == -1)
                break;
            if (pos2 == pos1 + 1) {
                result += template.substring(pos1, pos1 + 2);
                pos1 = pos2 + 1;
                continue;
            }
            tag = template.substring(pos1 + 1, pos2);
            pos3 = tag.indexOf("=");
            if (pos3 != -1) {
                value = vars[tag.substring(0, pos3)];
                if (value == null)
                    result += tag.substring(pos3 + 1);
                else
                    result += value;
            }
            else {
                value = vars[tag];
                if (value != null)
                    result += value;
            }
            pos1 = pos2 + 1;
        }
        if (pos1 < template.length)
            result += template.substring(pos1);
        return result;
    }
}
const objUidKey = Symbol();
